/*eslint-disable import/default*/
import "babel-polyfill";
import jquery from 'jquery'; //eslint-disable-line no-unused-vars
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import routes from './routes';
import configureStore from './redux/store/configureStore';
import contentProvider from './redux/modules/contentProvider/contentProvider';
import {contentProvider as sharedContentProvider} from './shared/packages/contentProvider'; //HACK: to enable shared components to access a shared content provider
import content from './redux/modules/contentProvider/content.json';
import { syncHistoryWithStore } from 'react-router-redux';
import './styles/styles.scss';

const store = configureStore();

contentProvider.setStore(store);
sharedContentProvider.setStore(store);
// TODO: provide content from API call
contentProvider.setContent(content);
sharedContentProvider.setContent(content);

const history = syncHistoryWithStore(browserHistory, store);

//window.trackingDebug = true;

render(
  <Provider store={store}>
    <Router
      history={history}
      onUpdate={() => document.getElementById('polaris-nav-header-wrapper').scrollIntoView()}
    >
      {routes(store.dispatch)}
    </Router>
  </Provider>, document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./client/index.js
 **/